/* eslint-disable import/prefer-default-export */

export const TAB_ACTION = {
  WORK_NOTES: '1',
  DEVICE_ACTIVITY: '2',
  RECORDINGS: '3',
  QC: '4', // Added QC tab
};


export const TAB_TEXT = {
  WORK_NOTES: ' Work Notes',
  DEVICE_ACTIVITY: 'Device Activity',
  RECORDINGS: 'Recordings',
  QC: 'QC', // Added QC tab
};

export const filterOptions = ['Email', 'Type', 'Date Range'];

export const workNotesFilterOptions = ['Email', 'Type', 'Date Range'];

export const deviceActivityFilterOptions = ['Email', 'Date Range', 'Initiated By'];

export const recordingsFilterOptions = ['Date Range'];

export const typeOptions = ['none', 'attachment'];
export const initiatedByOptions = ['user', 'system'];

export const DROP_DOWN_TEXT = {
  EMAIL: 'Email',
  TYPE: 'Type',
  DATE_RANGE: 'Date Range',
  INITIATED_BY: 'Initiated By',
};
